export default {
	name: "view-ex-tank-order",
	props:{
		orderExTankId: {
			default: null
		},
		orderId:{
			default: null
		}
	},
	data() {
		return {
			order: {},
			orderGrandTotal: 0,
			billingAddress:null,
			shippingAddress: null,
			reasonsForDeliveryFailure: [],
			deliveryProcessFeatureFlags: {},
			totalForOrder: 0,
			pagingDetails:{
				pageNumber: 1,
				pageSize: 10,
				totalPages: 1
			},
			dateOfCompletion:{
				value: new Date(),
				errorMessage: null,
				hasError: false,
				initialiseDate: true
			},
			orderItemsHasError: false,
			orderItemsErrorMessage: null,
			orderItemsHeadings: [
				{
					text: "Product",
					field: "product"
				},
				{
					text: "Price",
					field: "priceAsString"
				},
				{
					text: "Quantity/Litres",
					field: "quantity"
				},
				{
					text: "Amount Dispensed",
					field: "quantityDispensed"
				},
				{
					text: "Total",
					field: "totalAsString"
				},
				// {
				// 	text: "Total Price Dispensed",
				// 	field: "totalDispensedAsString"
				// }
			],
			trackingHistoryModal:{
				showModal: false,
				isSaving: false,
				modalId: "trackingHistoryModal",
				heading: "Tracking History",
				orderId: null
			},
			documentsModal:{
				modalId: "orderDocumentsModal",
				heading: "Order Documents",
				showModal: false,
				orderId: null,
				orderTypeId: null
			},
			orderItemsDispensed: [],
			cancelOrderModalId: "cancelOrderModal",
			markAsOnDeliveryModalId: "markAsOnDeliveryModal",
			cancelOrderScheduledForDeliveryModalId: "cancelOrderScheduledForDeliveryModal",
			completeOrderConfirmationModalId: "completeOrderConfirmationModal",
			orderStatus: {},
			actions: [],
			actionKeys:{
				edit: "edit",
				delete: "delete"
			},
			pageNumber: 1,
			pageSize: 100,
			loading: false,
			loadingBillingAddress: false,
			selectedHeartbeatStatusCodeId: null,
			orderTypeId: null
		};
	},
	methods: {
		getExTankOrder(){
			this.loading = true;
			exTankService.getExTankOrder(this.orderExTankId).then(
				successResponse =>{
					let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
					if(isSuccess){
						this.order = successResponse.data.result;
						this.order = dataTableHelper.castObjectValues(this.order);
						//this.order.orderItems = dataTableHelper.castObjectValues(this.order.orderItems);
						// for(let i = 0; i < this.order.orderItems.length; i++){
						// 	this.order.orderItems[i].priceAsString = currencyHelper.numberToCurrency(this.order.orderItems[i].unitPrice);
						// 	this.order.orderItems[i].totalAsString = currencyHelper.numberToCurrency(this.order.orderItems[i].totalAmount);
						// 	//this.order.orderItems[i].totalDispensedAsString = currencyHelper.numberToCurrency(this.order.orderItems[i].totalPriceDispensed);
						// 	//this.order.total += this.order.orderItems[i].total;
						// }
						this.order.totalAsString = currencyHelper.numberToCurrencyWithFourDecimalPlaces(this.order.totalAmount);
						this.orderGrandTotal = this.order.totalAmount;
						if(this.order.discountedAmount !== null && this.order.discountedAmount > 0) {
							this.orderGrandTotal = this.order.totalAmount - this.order.discountedAmount;
						}
						this.orderGrandTotal = currencyHelper.numberToCurrencyWithFourDecimalPlaces(this.orderGrandTotal);
						console.log("order", this.order);
						this.setBreadcrumbs();
						this.getCustomerBillingAddress();
					}
					this.loading = false;
					// setTimeout(function (){
					// 	var btnViewOrderCancel = document.getElementById("btnViewOrderCancel");
					// 	var btnViewOrderDownload = document.getElementById("btnViewOrderDownload");
					// 	var btnViewOrderViewTrackingHistory = document.getElementById("btnViewOrderDownload");
					// 	var viewOrderActions = document.getElementById("viewOrderActions");
					// 	if(btnViewOrderCancel.classList.contains("hide-element") &&
					// 		btnViewOrderDownload.classList.contains("hide-element") &&
					// 		btnViewOrderViewTrackingHistory.classList.contains("hide-element")){
					// 		viewOrderActions.classList.add("hide-element");
					// 	}
					// }, 100)

				},
				errorResponse => {
					console.log("error", errorResponse);
					this.loading = false;
					apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
				}
			);
		},
		getCustomerBillingAddress(){
			this.loadingBillingAddress = true;
			customerService.getCompanyAddress(this.order.billingAddressId).then(
				successResponse => {
					let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
					if(isSuccess){
						this.billingAddress = successResponse.data.result;
					}
					this.loadingBillingAddress = false;
				},
				errorResponse => {
					console.log("error", errorResponse);
					this.loadingBillingAddress = false;
					apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
				}
			);
		},
		onCancelOrderClick(){
			$("#" + this.cancelOrderModalId).modal("show");
		},
		onCancelYesClick(){
			this.loading = true;
			let request = {
				orderId: this.order.orderId,
				companyId: this.order.companyId
			};
			orderService.cancelOrder(request).then(
				successResponse => {
					let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
					if(isSuccess){
						this.getExTankOrder();
					}
					$("#" + this.cancelOrderModalId).modal("hide");
					this.loading = false;
				},
				errorResponse => {
					console.log("error", errorResponse);
					this.loading = false;
					apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
				}
			);
		},
		onDocumentsActionClick(){
			this.documentsModal.showModal = true;
			this.documentsModal.orderId = this.order.orderId;
			this.documentsModal.heading = "Order Documents - #" + this.order.orderId;
			this.documentsModal.orderTypeId = orderHelper.orderType.exTank;
		},
		onDocumentsModalClose(){
			this.documentsModal.showModal = false;
			this.documentsModal.orderId = null;
		},
		viewTrackingHistory() {
			this.trackingHistoryModal.showModal = true;
			this.trackingHistoryModal.orderId = this.order.orderId;
			this.trackingHistoryModal.heading = "Tracking History - #" + this.order.orderId + " (" + this.order.registeredCompanyName + ")";
		},
		onTrackingHistoryOkButtonClicked(){
			this.trackingHistoryModal.showModal = false;
		},
		reviewOrder(){
			this.$router.push("/orders/extank/reviewOrder/" + this.order.orderExTankId + "/" + this.order.orderId);
		},
		completeReview(){
			this.$router.push("/orders/extank/reviewOrder/" + this.order.orderExTankId + "/" + this.order.orderId);
		},
		completeOrder(){
			this.$router.push("/orders/extank/completeOrder/" + this.order.orderExTankId + "/" + this.order.orderId);
		},
		downloadOrderAsPdf(){
			exTankService.getExTankOrderAsPdf(this.order.orderId);
		},
		setBreadcrumbs() {
			let pageTitle = "View Ex-Tank Order - #" + this.order.orderId + " (" + this.order.registeredCompanyName + ")";
			storeState.setPageTitleAction(pageTitle);
			breadcrumbsStoreState.updateBreadcrumbs(this.$route, pageTitle);
		},
	},
	mounted: function () {
		this.orderStatus = orderHelper.orderStatus;
		this.orderTypeId = orderHelper.orderType.exTank;
	},
	watch:{
		orderExTankId:{
			handler: function () {
				if (this.orderExTankId !== null && this.orderExTankId > 0) {
					this.getExTankOrder();
				}
			},
			immediate: true,
			deep: true
		}
	}
};